import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; 

import { ParametersComponent } from './parameters.component'; 
import { AddparameterComponent } from './addparameter.component'; 

import { ViewparameterComponent } from './viewparameter.component';  

// Auth
import { AuthGuard } from '../_guards/index';

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'System Settings'
    }, 
    canActivate: [AuthGuard],
    children: [
     
    {
        path: 'viewparameter',
        component: ViewparameterComponent,
        data: {
          title: 'View Parameters'
        }
      },
    {
        path: 'parameters',
        component: ParametersComponent,
        data: {
          title: 'Parameters'
        }
      },
      {
        path: 'addparameter',
        component: AddparameterComponent,
        data: {
          title: 'Add Parameter'
        }
      } 
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)], 
  exports: [RouterModule]
})
export class SystemsRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/systems/systems-routing.module.ts